export default {
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'calc(100vh - 150px)'
    },
    img: {
      height: 300
    },
    inputContainer : {
        marginTop: 15,
        display: 'flex',
        flexDirection:  'column',
        alignItems:  'flex-start'
    },
    label: {
        fontFamily: "Questrial",
        fontSize: 18
    },
    input: {
        marginTop: 5,
        width: 300
    },
    innerInput : {
        padding: [8,15]
    },
    button: {
        marginTop: 30,
        marginBottom:10,
        fontFamily: 'Questrial'
    },
    Text:{
        marginTop: 30,
        fontFamily: 'Questrial',
        fontSize: 17,
    },
    divider: {
        width: 300,
        height: 1,
        backgroundColor: '#e8e8e8',
        margin:[0,0,20,0]
    },
    SubText:{
        fontFamily: 'Questrial',
        fontSize: 17,
    },
    loader: {
        marginTop: 30,
    },
}
